import styles from './BoxShareLink.module.css';
import Button from '../Common/Button/Button';
import { removeProtocol } from '../../helpers/url';

const BoxShareLink = ({ link, shareButtonText, onShareClick }) => {
  const handleShare = () => {
    if (onShareClick) {
      onShareClick(link);
    }
  };

  return (
    <div className={styles.boxLink}>
      <span className={styles.linkText}>{removeProtocol(link)}</span>
      <Button
        onClick={handleShare}
        size='large'
        width={86}
        className={styles.share}
        text={shareButtonText}
        iconColor='#000'
      />
    </div>
  );
};

export default BoxShareLink;
